import { createAuthClient } from "better-auth/react";
import { stripeClient } from "@better-auth/stripe/client";
import { inferAdditionalFields } from "better-auth/client/plugins";
import type { auth } from "auth";

// Determine which environment we're in and get the base URL accordingly
const getBaseURL = () => {
  // Check if we're in a Playwright test environment
  if (typeof process !== "undefined" && process.env) {
    return process.env.VITE_BASE_URL || process.env.PLAYWRIGHT_BASE_URL;
  }
  // Otherwise use import.meta.env (Vite environment)
  return import.meta.env.VITE_BASE_URL;
};

export const authClient = createAuthClient({
  baseURL: getBaseURL(),
  plugins: [
    inferAdditionalFields<typeof auth>(),
    stripeClient({
      subscription: true,
    }),
  ],
});

export const {
  signIn,
  signUp,
  deleteUser,
  changeEmail,
  signOut,
  useSession,
  subscription,
  forgetPassword,
  resetPassword,
} = authClient;
